// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los números que se muestran en los display
 * @param {*} scene 
 */
export function cargaAssetsNumerosDisplay(scene) {
  scene.load.image(
    "numeroDisplay0",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay0Resized.png"
  );
  scene.load.image(
    "numeroDisplay1",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay1Resized.png"
  );
  scene.load.image(
    "numeroDisplay2",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay2Resized.png"
  );
  scene.load.image(
    "numeroDisplay3",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay3Resized.png"
  );
  scene.load.image(
    "numeroDisplay4",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay4Resized.png"
  );
  scene.load.image(
    "numeroDisplay5",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay5Resized.png"
  );
  scene.load.image(
    "numeroDisplay6",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay6Resized.png"
  );
  scene.load.image(
    "numeroDisplay7",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay7Resized.png"
  );
  scene.load.image(
    "numeroDisplay8",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay8Resized.png"
  );
  scene.load.image(
    "numeroDisplay9",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplay9Resized.png"
  );
  scene.load.image(
    "numeroDisplayVacio",
    ROUTES.rutaBlackJackNumerosDisplay + "/numeroDisplayVacioResized.png"
  );
}